import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './zh'
import en from './en'
import { detectLocale, setDocumentLocale, withLocalePrefix, stripLocalePrefix } from './locale'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: detectLocale(),
  fallbackLocale: 'zh',
  silentFallbackWarn: true,
  messages: { zh, en }
})

setDocumentLocale(i18n.locale)

Vue.mixin({
  methods: {
    localePath(target) {
      const locale = (this.$i18n && this.$i18n.locale) || 'zh'
      if (typeof target === 'string') {
        return withLocalePrefix(target, locale)
      }
      if (!target || typeof target !== 'object') {
        return withLocalePrefix('/', locale)
      }
      const path = target.path || '/'
      return {
        ...target,
        path: withLocalePrefix(path, locale)
      }
    },
    stripLocalePath(path) {
      return stripLocalePrefix(path || '/')
    }
  }
})

export default i18n
